import { useEffect, useState } from "react";
import PrevOutstanding from "@/components/common/PrevOutstanding";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { inr, fmtDate } from "@/lib/format";
import { Loading } from "@/components/common/kit";
import { ReconPanel } from "@/components/common/DayView";

export default function SCollections() {
  const { salesman, bizDate } = useAuth();
  const { data: day, setData } = useFetch(`/day/${salesman.id}/${bizDate}`);
  const { data: hist } = useFetch("/closures", { status: "CLOSED", limit: 10 });
  const [m, setM] = useState({ cash: "", gpay: "" });
  useEffect(() => { if (day) setM({ cash: day.cash ?? "", gpay: day.gpay ?? "" }); }, [day]);
  if (!day) return <Loading />;
  const locked = day.status === "CLOSED";
  const save = async () => {
    if (m.cash === "" || m.gpay === "") return toast.error("Enter Cash and GPay/UPI (0 if none).");
    try {
      const r = await api.put(`/day/${salesman.id}/${bizDate}/draft`, { cash: Number(m.cash), gpay: Number(m.gpay) });
      setData(r.data);
      toast.success("Collection saved");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold tracking-tight">Collections</h1>
      <PrevOutstanding />
      <div className="space-y-4 rounded-md border border-slate-200 bg-white p-4">
        <p className="text-xs text-slate-500">Today · {fmtDate(bizDate)}{locked && " · locked"}</p>
        {[["cash", "Cash Collected (₹)"], ["gpay", "GPay / UPI (₹)"]].map(([k, l]) => (
          <label key={k} className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-600">{l}</span>
            <Input type="number" inputMode="decimal" disabled={locked} value={m[k]} onChange={(e) => setM({ ...m, [k]: e.target.value })} className="mt-1 h-14 font-mono text-xl font-bold" data-testid={`coll-${k}-input`} />
          </label>
        ))}
        {!locked && <Button className="h-12 w-full" onClick={save} data-testid="coll-save-button">Save collection</Button>}
        <ReconPanel day={day} />
        {day.validation?.missing_closing > 0 && <p className="text-xs text-amber-700">Sales value updates after you enter closing stock in Close Day.</p>}
      </div>
      <div>
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.15em] text-slate-500">Recent closed days</p>
        <div className="divide-y divide-slate-100 rounded-md border border-slate-200 bg-white">
          {(hist?.items || []).map((c) => (
            <div key={c.id} className="grid grid-cols-4 gap-2 px-4 py-2.5 text-xs">
              <span className="font-semibold">{fmtDate(c.date)}</span><span className="font-mono">C {inr(c.cash)}</span><span className="font-mono">G {inr(c.gpay)}</span>
              <span className={`text-right font-mono ${c.receivable > 0 ? "text-red-600" : "text-slate-600"}`}>{c.receivable > 0 ? `Due ${inr(c.receivable)}` : c.surplus > 0 ? `+${inr(c.surplus)}` : "OK"}</span>
            </div>
          ))}
          {hist?.items?.length === 0 && <p className="px-4 py-3 text-sm text-slate-500">No closed days yet.</p>}
        </div>
      </div>
    </div>
  );
}
